import { Box, Typography, useTheme } from '@mui/material';
import FlightBar from './FlightBar';
import { LABEL_W, toMins } from './constants';

const TimelineRow = ({ label, flights, acTypeColorMap, hourWidth = 56, rowHeight = 32 }) => {
  const theme  = useTheme();
  const totalW = 24 * hourWidth;

  return (
    <Box
      sx={{
        display: 'flex',
        height: rowHeight,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      {/* Sticky label */}
      <Box
        sx={{
          position: 'sticky',
          left: 0,
          zIndex: 1,
          width: LABEL_W,
          flexShrink: 0,
          bgcolor: 'background.paper',
          borderRight: `1px solid ${theme.palette.divider}`,
          display: 'flex',
          alignItems: 'center',
          px: 0.5,
        }}
      >
        <Typography variant="caption" fontFamily="monospace" color="text.secondary" noWrap>
          {label}
        </Typography>
      </Box>

      {/* Bar area */}
      <Box sx={{ position: 'relative', height: rowHeight, width: totalW, flexShrink: 0 }}>
        {/* Hour grid lines */}
        {Array.from({ length: 25 }, (_, i) => (
          <Box
            key={i}
            sx={{
              position: 'absolute',
              left: i * hourWidth,
              top: 0, bottom: 0,
              borderLeft: `1px solid ${theme.palette.divider}`,
              opacity: 0.3,
            }}
          />
        ))}
        {/* Night shading 00-06 and 22-24 */}
        <Box sx={{ position: 'absolute', left: 0, width: 6 * hourWidth, top: 0, bottom: 0, bgcolor: 'rgba(0,0,0,0.06)', pointerEvents: 'none' }} />
        <Box sx={{ position: 'absolute', left: 22 * hourWidth, width: 2 * hourWidth, top: 0, bottom: 0, bgcolor: 'rgba(0,0,0,0.06)', pointerEvents: 'none' }} />

        {flights.map((f) => {
          const stdM = toMins(f.std);
          const staM = toMins(f.sta);
          if (stdM === null || staM === null) return null;
          const dur   = staM >= stdM ? staM - stdM : (24 * 60 - stdM + staM);
          const color = acTypeColorMap[f.acType] || '#607d8b';
          return (
            <FlightBar
              key={f._id}
              flight={f}
              startMins={stdM}
              durationMins={dur}
              color={color}
              hourWidth={hourWidth}
              rowHeight={rowHeight}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default TimelineRow;
